import { useSelector } from 'react-redux';

import {
  BNPL_MAX_TRANSACTION_UNIT_AMOUNT,
  BNPL_MIN_TRANSACTION_UNIT_AMOUNT,
} from 'constants/bnpl';
import { getBookingEstimateUnitPrice } from 'selectors/services';

import { useBnplPromo } from 'hooks/bnpl/useBnplPromo';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';
import { useBnplSettingsFeatureFlag } from 'routes/invoices/useBnplFeatureFlag';

import { convertSubunitsToDecimal } from 'utils/payments/money';

import s from './Pricing.module.css';

export const Pricing = () => {
  const bnplPromoFF = useBnplSettingsFeatureFlag();
  const { isEnabled, bnplCapabilities } = useBnplPromo();
  const bookingEstimateUnitPrice = useSelector(getBookingEstimateUnitPrice);
  const bookingEstimateDecimalPrice = convertSubunitsToDecimal(
    bookingEstimateUnitPrice,
  );
  const { theme } = useGGTheme();
  const isEnergyTheme = theme?.palette.name === 'Energy';
  const lightMode = theme?.palette.mode === 'light';

  const overrideColor = isEnergyTheme && lightMode;

  const promoTextColor = overrideColor
    ? (theme?.palette.textSecondary as string)
    : (theme?.palette.textPrimary as string);
  const promoBackgroundColor = overrideColor
    ? '#fff'
    : (theme?.palette.bgPrimary as string);

  const bnplEligible =
    isEnabled &&
    bookingEstimateUnitPrice >= BNPL_MIN_TRANSACTION_UNIT_AMOUNT &&
    bookingEstimateUnitPrice <= BNPL_MAX_TRANSACTION_UNIT_AMOUNT;

  return bnplPromoFF.isEnabled ? (
    <section className={s.apptInfo}>
      <h2 className={s.title}>Total Price</h2>
      <p className={s.infoItem}>
        From ${bookingEstimateDecimalPrice} {bnplEligible ? 'or' : ''}
      </p>
      {bnplEligible && (
        <>
          <div className={s.bnplContainer}>
            <BuyNowPayLaterPromo
              unitAmount={bookingEstimateUnitPrice}
              textAlign="center"
              paymentMethodTypes={bnplCapabilities}
              textColor={promoTextColor}
              backgroundColor={promoBackgroundColor}
            />
          </div>
          <p className={s.badge}>Available at in-person checkout</p>
        </>
      )}
    </section>
  ) : null;
};
